import { formatDateLong } from '../../../utils/formatDateLong';
export var prepareLastActivityDate = function prepareLastActivityDate(lastActivityDate) {
  if (!lastActivityDate) {
    return;
  }
  return formatDateLong(new Date(lastActivityDate));
};